import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyConverter'
})
export class CurrencyConverterPipe implements PipeTransform {

  transform(value: any, totalDecimals?: number): any {
    if (value == null) {
      return null;
    }

    const countDecimals = this.countDecimals(value);

    if (countDecimals === 1) {
      return value.toString() + '0';
    }

    if (countDecimals > 2) {
      if (totalDecimals) {
        return value.toFixed(totalDecimals);
      }
      return value.toFixed(2);
    }

    return value.toString();
  }

  countDecimals(value) {
    if (Math.floor(value) === value) {
      return 0;
    }

    return value?.toString()?.split('.')[1].length || 0;
  }

}
